import { useState, useEffect } from "react";
import { useGetAllNamirniceQuery } from "../features/Namirnice/namirniceApiSlice";
import {
  useGetAllSpecCiljeviQuery,
  useAddNewSpecCiljMutation,
  useUpdateSpecCiljMutation,
  useDeleteSpecCiljMutation,
} from "../features/ciljevi/ciljeviApiSlice";

function SpecCilj() {
  const [specCiljNaziv, setSpecCiljNaziv] = useState("");
  const [selectedNamirnice, setSelectedNamirnice] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedCilj, setSelectedCilj] = useState(null);
  const [selectedValueTipSpec, setSelectedValueTipSpec] = useState(""); //Tip sepc cilja
  // const [newCheckboxName, setNewCheckboxName] = useState('');
  // const [customCheckboxes, setCustomCheckboxes] = useState([]);

  const {
    data: getSpecCiljeviData,
    isSuccess: isSuccessGetSpecCiljevi,
    isError: isErrorGetSpecCiljevi,
    error: getSpecCiljeviError,
  } = useGetAllSpecCiljeviQuery();
  const [
    addSpecCilj,
    {
      isSuccess: isSuccessAddSpecCilj,
      isError: isErrorAddSpecCilj,
      error: errorAddSpecCilj,
      data: dataAddSpecCilj,
    },
  ] = useAddNewSpecCiljMutation();
  const [
    updateSpecCilj,
    {
      isSuccess: isSuccessUpdateSpecCilj,
      isError: isErrorUpdateSpecCilj,
      error: errorUpdateSpecCilj,
      data: dataUpdateSpecCilj,
    },
  ] = useUpdateSpecCiljMutation();
  const [
    deleteSpecCilj,
    {
      isSuccess: isSuccessDelSpecCilj,
      isError: isErrorDelSpecCilj,
      error: errorDelSpecCilj,
      data: dataDelSpecCilj,
    },
  ] = useDeleteSpecCiljMutation();
  const { data: namirniceData, isSuccess: isSuccessGetNamir } =
    useGetAllNamirniceQuery();

  //deleteSpecCilj
  const openModal = () => {
    setIsModalOpen(true);
    setIsEdit(false);
    setSpecCiljNaziv("");
    setSelectedNamirnice([]);
    // setCustomCheckboxes([]);

    //Da pri kreiranju doda da se svi chekboxovi chekiraju
    const allNamirniceIds = namirnice.map((namirnica) => namirnica._id);
    setSelectedNamirnice(allNamirniceIds);
  };

  const openEditModal = (cilj) => {
    setSelectedCilj(cilj);
    setIsEdit(true);
    setIsModalOpen(true);
    setSpecCiljNaziv(cilj.naziv);
    setSelectedValueTipSpec(cilj.defTip); //here
    // setCustomCheckboxes(cilj.podciljevi);
    setSelectedNamirnice(cilj.namirnice.map((n) => n._id || n));
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsEdit(false);
    setSelectedCilj(null);
    setSpecCiljNaziv("");
    setSelectedNamirnice([]);
  };

  const onSpecCiljNazivChange = (e) => setSpecCiljNaziv(e.target.value);

  const onNamirnicaCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setSelectedNamirnice((prevSelected) =>
      checked
        ? [...prevSelected, value]
        : prevSelected.filter((id) => id !== value)
    );
  };
  //selectedValueTipSpec
  const handleAddSpecCilj = async () => {
    if (!specCiljNaziv) {
      alert("Molimo Vas unesite naziv specifičnog cilja.");
      return;
    }

    if (!selectedValueTipSpec) {
      alert("Molimo Vas unesite tip specifičnog cilja.");
      return;
    }
    await addSpecCilj({
      naziv: specCiljNaziv,
      namirnice: selectedNamirnice,
      tip: "specCilj",
      selectedValueTipSpec,
    });
    closeModal();
  };

  const handleUpdateSpecCilj = async () => {
    if (!selectedCilj) return;

    if (!selectedValueTipSpec) {
      alert("Molimo Vas unesite tip specifičnog cilja.");
      return;
    }
    await updateSpecCilj({
      id: selectedCilj._id,
      naziv: specCiljNaziv,
      namirnice: selectedNamirnice,
      selectedValueTipSpec,
    });
    closeModal();
  };

  const handleDeleteSpecCilj = async (id) => {
    await deleteSpecCilj({ id });
  };

  const handleClickOutside = (e) => {
    if (e.target.classList.contains("modal-background")) {
      closeModal();
    }
  };

  const handleChangeTipSpec = (event) => {
    setSelectedValueTipSpec(event.target.value);
  };

  const specCiljevi = isSuccessGetSpecCiljevi
    ? Object.values(getSpecCiljeviData?.entities || {})
    : [];
  const namirnice = isSuccessGetNamir
    ? Object.values(namirniceData?.entities || [])
    : [];

  // Function to group namirnice by their 'grupa' and 'podtip'
  const groupNamirnice = (namirnice) => {
    const grouped = {};

    namirnice.forEach((namirnica) => {
      const { grupa, podtip } = namirnica;

      if (!grouped[grupa]) {
        grouped[grupa] = {};
      }

      if (!grouped[grupa][podtip]) {
        grouped[grupa][podtip] = [];
      }

      grouped[grupa][podtip].push(namirnica);
    });

    return grouped;
  };

  const groupedNamirnice = groupNamirnice(namirnice);

  // Get spec ciljevi
  useEffect(() => {
    if (isSuccessGetSpecCiljevi) {
      // console.log("Učitani specifični ciljevi:", specCiljevi);
    }

    if (isErrorGetSpecCiljevi) {
      const errorMessage = getSpecCiljeviError?.data?.message;
      alert(errorMessage);
    }
  }, [
    isSuccessGetSpecCiljevi,
    isErrorGetSpecCiljevi,
    getSpecCiljeviError,
    specCiljevi,
  ]);

  // Add spec cilj
  useEffect(() => {
    if (isSuccessAddSpecCilj) {
      alert(dataAddSpecCilj?.message || "Specifičan cilj uspešno dodat!");
    }

    if (isErrorAddSpecCilj) {
      const errorMessage = errorAddSpecCilj?.data?.message;
      alert(errorMessage);
    }
  }, [
    isSuccessAddSpecCilj,
    isErrorAddSpecCilj,
    errorAddSpecCilj,
    dataAddSpecCilj,
  ]);

  // Update spec cilj
  useEffect(() => {
    if (isSuccessUpdateSpecCilj) {
      alert(dataUpdateSpecCilj?.message || "Specifičan cilj uspešno ažuriran!");
    }

    if (isErrorUpdateSpecCilj) {
      const errorMessage = errorUpdateSpecCilj?.data?.message;
      alert(errorMessage);
    }
  }, [
    isSuccessUpdateSpecCilj,
    isErrorUpdateSpecCilj,
    errorUpdateSpecCilj,
    dataUpdateSpecCilj,
  ]);

  // Delete spec cilj
  useEffect(() => {
    if (isSuccessDelSpecCilj) {
      alert(dataDelSpecCilj || "Specifičan cilj uspešno obrisan!");
    }

    if (isErrorDelSpecCilj) {
      const errorMessage = errorDelSpecCilj?.data?.message;
      alert(errorMessage);
    }
  }, [
    isSuccessDelSpecCilj,
    isErrorDelSpecCilj,
    errorDelSpecCilj,
    dataDelSpecCilj,
  ]);

  //Za checkboxove
  // const handleAddCheckbox = () => {
  //   if (newCheckboxName.trim()) {
  //     setCustomCheckboxes([...customCheckboxes, newCheckboxName]);
  //     setNewCheckboxName('');
  //   }
  // };

  // const handleDeleteCheckbox = (index) => {
  //   setCustomCheckboxes(customCheckboxes.filter((_, i) => i !== index));
  // };

  return (
    <div className="block w-full h-100 bg-gray-100 p-2 border-black">
      <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
        <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
          <div className="ml-4 mt-2">
            <div className="flex items-center space-x-2">
              <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                Dodaj specifičan cilj
              </h3>
            </div>
          </div>
          <div className="ml-4 mt-2 flex-shrink-0">
            <button
              onClick={openModal}
              className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
            >
              Dodaj
            </button>
          </div>
        </div>

        <ul className="mt-4">
          {specCiljevi
            .slice()
            .reverse()
            .map((cilj) => (
              <li
                key={cilj._id}
                className="flex justify-between items-center border-b border-gray-200 py-3"
              >
                <span className="text-md font-semibold text-gray-900">
                  {cilj.naziv}
                </span>
                <div className="flex items-center">
                  <button
                    onClick={() => openEditModal(cilj)}
                    className="ml-4 text-blue-600 hover:text-blue-500"
                  >
                    Izmeni
                  </button>
                  <button
                    onClick={() => handleDeleteSpecCilj(cilj._id)}
                    className="ml-4 text-red-600 hover:text-red-500"
                  >
                    Ukloni
                  </button>
                </div>
              </li>
            ))}
        </ul>
      </div>

      {isModalOpen && (
        <div
          className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50 modal-background"
          onClick={handleClickOutside}
        >
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
            <h2 className="text-lg font-semibold mb-4">
              {isEdit ? "Izmeni specifičan cilj" : "Dodaj specifičan cilj"}
            </h2>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Naziv cilja
              </label>
              <input
                type="text"
                value={specCiljNaziv}
                onChange={onSpecCiljNazivChange}
                className="mt-1 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Tip cilja
              </label>
              <select
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                value={selectedValueTipSpec}
                onChange={handleChangeTipSpec}
              >
                <option value="">--Izaberite--</option>
                <option value="Bolesti i Zdravstveni Problemi">
                  Zdravstveni izazovi
                </option>
                <option value="Mentalno Zdravlje i Psihološki Aspekti">
                  Mentalno zdravlje
                </option>
                <option value="Fizička Kondicija i Performanse">
                  Fizička forma
                </option>
                <option value="Zdravstvene Navike i Prevencija">
                  Zdrave navike
                </option>
                <option value="Specifični Ciljevi za Životni Stil">
                  Ciljevi za životni stil
                </option>
              </select>
            </div>
            {/* Deo za dodavanje novih checkboxova */}
            {/* <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">Dodajte novi podcilj</label>
              <div className="flex items-center mt-2">
                <input
                  type="text"
                  value={newCheckboxName}
                  onChange={(e) => setNewCheckboxName(e.target.value)}
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  placeholder="Unesite naziv podcilja"
                />
                <button
                  onClick={handleAddCheckbox}
                  className="ml-2 px-3 py-2 bg-blue-500 text-white rounded-md shadow-sm hover:bg-blue-600"
                >
                  Dodaj
                </button>
              </div>
            </div> */}
            {/* Prikaz kreiranih checkboxova sa skrolom i opcijom za brisanje */}
            {/* <div className="mb-4">
              <h4 className="text-sm font-medium text-gray-700">Kreirani podciljevi</h4>
              <div className="mt-2 space-y-2 overflow-y-auto" style={{ maxHeight: '150px' }}>
                {customCheckboxes.length > 0 ? (
                  customCheckboxes.map((checkbox, index) => (
                    <div key={index} className="flex items-center justify-between">
                      <div className="flex items-center">
                        <input type="checkbox" disabled className="mr-2" checked/>
                        <label>{checkbox}</label>
                      </div>
                      <button
                        onClick={() => handleDeleteCheckbox(index)}
                        className="text-red-600 hover:text-red-800 ml-2"
                      >
                        Ukloni
                      </button>
                    </div>
                  ))
                ) : (
                  <p className="text-gray-500">Nema podciljeva.</p>
                )}
              </div>
            </div> */}
            <div className="my-1">
              <label className="block text-sm font-medium text-gray-700">
                Izaberite namirnice
              </label>
              <div
                className="mt-2 grid grid-cols-1 gap-4 overflow-y-auto"
                style={{ maxHeight: "200px" }}
              >
                {Object.keys(groupedNamirnice).length > 0 ? (
                  Object.keys(groupedNamirnice).map((grupa) => (
                    <div key={grupa}>
                      <h3 className="font-semibold text-gray-800">{grupa}</h3>
                      {Object.keys(groupedNamirnice[grupa]).map((podtip) => (
                        <div key={podtip} className="mt-2 ml-4">
                          <h4 className="font-medium text-gray-700">
                            {podtip}
                          </h4>
                          {groupedNamirnice[grupa][podtip].map((namirnica) => (
                            <div
                              key={namirnica._id}
                              className="flex items-center ml-8"
                            >
                              <input
                                type="checkbox"
                                value={namirnica._id}
                                checked={selectedNamirnice.includes(
                                  namirnica._id
                                )}
                                onChange={onNamirnicaCheckboxChange}
                                className="mr-2"
                              />
                              <label>{namirnica.naziv}</label>
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>
                  ))
                ) : (
                  <p className="text-gray-500">Nema dostupnih namirnica.</p>
                )}
              </div>
            </div>

            <div className="flex justify-end">
              <button
                onClick={closeModal}
                className="px-4 py-2 mr-2 bg-gray-500 text-white rounded-md"
              >
                Odustani
              </button>
              <button
                onClick={isEdit ? handleUpdateSpecCilj : handleAddSpecCilj}
                className="px-4 py-2 bg-blue-600 text-white rounded-md"
              >
                {isEdit ? "Izmeni" : "Dodaj"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Popup modal za dodavanje ili izmenu cilja */}
      {/* {isModalOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50 modal-background" onClick={handleClickOutside}>
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
            <h2 className="text-lg font-semibold mb-4">{isEdit ? 'Izmeni specifičan cilj' : 'Dodaj specifičan cilj'}</h2>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">Naziv cilja</label>
              <input
                type="text"
                value={specCiljNaziv}
                onChange={onSpecCiljNazivChange}
                className="mt-1 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
              />
            </div>
            <div>
            <label className="block text-sm font-medium text-gray-700">Tip cilja</label>
              <select className='block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6' value={selectedValueTipSpec} onChange={handleChangeTipSpec}>
                  <option value="">--Izaberite--</option>
                  <option value="Bolesti i Zdravstveni Problemi">Bolesti i Zdravstveni Problemi</option>
                  <option value="Mentalno Zdravlje i Psihološki Aspekti">Mentalno Zdravlje i Psihološki Aspekti</option>
                  <option value="Fizička Kondicija i Performanse">Fizička Kondicija i Performanse</option>
                  <option value="Zdravstvene Navike i Prevencija">Zdravstvene Navike i Prevencija</option>
                  <option value="Specifični Ciljevi za Životni Stil">Specifični Ciljevi za Životni Stil</option>
              </select>
          </div>
            <div className="my-1">
              <label className="block text-sm font-medium text-gray-700">Izaberite namirnice</label>
              <div className="mt-2 grid grid-cols-1 gap-4 overflow-y-auto" style={{ maxHeight: '200px' }}>
                {Object.keys(groupedNamirnice).length > 0 ? (
                  Object.keys(groupedNamirnice).map((grupa) => (
                    <div key={grupa}>
                      <h3 className="font-semibold text-gray-800">{grupa}</h3>
                      {Object.keys(groupedNamirnice[grupa]).map((podtip) => (
                        <div key={podtip} className="mt-2 ml-4">
                          <h4 className="font-medium text-gray-700">{podtip}</h4>
                          {groupedNamirnice[grupa][podtip].map((namirnica) => (
                            <div key={namirnica._id} className="flex items-center ml-8">
                              <input
                                type="checkbox"
                                value={namirnica._id}
                                checked={selectedNamirnice.includes(namirnica._id)}
                                onChange={onNamirnicaCheckboxChange}
                                className="mr-2"
                              />
                              <label>{namirnica.naziv}</label>
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>
                  ))
                ) : (
                  <p className="text-gray-500">Nema dostupnih namirnica.</p>
                )}
              </div>
            </div>

            <div className="flex justify-end">
              <button
                onClick={closeModal}
                className="px-4 py-2 mr-2 bg-gray-500 text-white rounded-md"
              >
                Odustani
              </button>
              <button
                onClick={isEdit ? handleUpdateSpecCilj : handleAddSpecCilj}
                className="px-4 py-2 bg-blue-600 text-white rounded-md"
              >
                {isEdit ? 'Izmeni' : 'Dodaj'}
              </button>
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
}

export default SpecCilj;
